import { getEnv } from "@utils/get-env";
import axios from "axios";

const API_URL = `${getEnv("REACT_APP_API_URL")}/api/v1/offers`;

export const getApiUrl = (offerId: number, attachmendId: number) =>
  `${API_URL}/${offerId}/attachments/${attachmendId}`;

export const putFileName = async (offerId: number, fileName: string, attachmentId: number) => {
  const BASE_URL = `${getApiUrl(offerId, attachmentId)}/filename`;

  await axios.put(BASE_URL, {
    fileName,
  });
};

export const putSortOrder = async (offerId: number, sortOrder: number, attachmentId: number) => {
  const BASE_URL = `${getApiUrl(offerId, attachmentId)}/sortOrder`;

  await axios.put(BASE_URL, {
    sortOrder,
  });
};
